export const avatar =
  'https://firebasestorage.googleapis.com/v0/b/usm-sign.appspot.com/o/template%2Favatar.png?alt=media&token=174fcad0-888f-46d8-acc9-3c25312ba4d5'
